import { useQuery } from '@tanstack/react-query';
import statusApiFunctions from '../api/status';
import { Queries } from '../types/queries';
import { QueueStatusCheckModel } from '../types/queueStatus';
import { useEffect, useRef } from 'react';

const useQueueStatusData = (callback: Function) => {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;
  const {
    data,
    dataUpdatedAt,
    isFetching,
    isLoading,
    isError,
    refetch: queryRefetch,
  } = useQuery<Array<QueueStatusCheckModel>>({
    queryKey: Object.values(Queries.QueueStatusList),
    queryFn: async () => await statusApiFunctions.getQueueStatuses(),
    refetchInterval: 300000, //5 min refresh
  });

  useEffect(() => callbackRef.current(data), [data, dataUpdatedAt]);

  const refetch = async () => {
    const result = await queryRefetch();
    callbackRef.current(result.data);
    return result;
  };

  return { data, isFetching, isLoading, isError, refetch };
};

export default useQueueStatusData;
